/**
 * @surfline/web-common v11.2.4 2020-10-06
 */

import 'core-js/modules/es.object.to-string';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.reverse';
import 'core-js/modules/es.map';
import 'core-js/modules/web.dom-collections.iterator';

var minDegreesCardinalMap = new Map([[0, 'N'], [11.25, 'NNE'], [33.75, 'NE'], [56.25, 'ENE'], [78.75, 'E'], [101.25, 'ESE'], [123.75, 'SE'], [146.25, 'SSE'], [168.75, 'S'], [191.25, 'SSW'], [213.75, 'SW'], [236.25, 'WSW'], [258.75, 'W'], [281.25, 'WNW'], [303.75, 'NW'], [326.25, 'NNW'], [348.75, 'N']]);
var mapDegreesCardinal = (function (degrees) {
  var minDegrees = _toConsumableArray(minDegreesCardinalMap.keys()).reverse().find(function (key) {
    return degrees >= key;
  }) || 0;
  return minDegreesCardinalMap.get(minDegrees);
});

export default mapDegreesCardinal;
//# sourceMappingURL=mapDegreesCardinal.js.map
